import { render, staticRenderFns } from "./planocurricular.vue?vue&type=template&id=64aabae0&"
import script from "./planocurricular.vue?vue&type=script&lang=js&"
export * from "./planocurricular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports